export const API = {
  endpoint: window.location.hostname === "localhost" ? "https://api.voico.rejoicehub.com/api/v1/" : "https://api.voico.rejoicehub.com/api/v1/",
};
